<template>
  <base-wrapper :loading="loadingRewards || form.loading || deleteConfirm.loading || requireModal.loading || imageModal.loading || requireForm.loading || imageForm.loading || deleteRequireLoading || deleteImageLoading">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Reward
        </base-button>
      </div>
      <datatable
        :total="rewards.meta.page.total"
        :perPage="rewards.meta.page.perPage"
        :currentPage="rewards.meta.page.currentPage"
        :columns="[
          { id: 'name', name: 'Judul' },
          { id: 'description', name: 'Deskripsi' },
          { id: 'periodd', name: 'Tanggal' },
          { id: 'action', name: 'Aksi' },
        ]"
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="reward in rewards.data"
            :key="reward.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ reward.attributes.title }}</td>
            <td :class="classes.td">
              <p class="truncate">{{ reward.attributes.description }}</p>
            </td>
            <td :class="classes.td">{{ reward.attributes.start_date | formatDate }} - {{ reward.attributes.end_date | formatDate }}</td>
            <td :class="[classes.td]">
              <div class="flex gap-2">
                <BaseButton
                  size="sm"
                  color="white"
                  @click="onOpenRequire(reward)"
                >
                  Daftar Syarat
                </BaseButton>
                <BaseButton
                  size="sm"
                  color="white"
                  @click="onOpenImage(reward)"
                >
                  Daftar Gambar
                </BaseButton>
                <div class="flex gap-1">
                  <button
                    class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                    @click="onEdit(reward)"
                  >
                    <Icon icon="heroicons:pencil-square-solid" class="w-4 h-4" />
                  </button>
                  <button
                    class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                    @click="onDelete(reward)"
                  >
                    <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="requireModal.visible"
      @close="requireModal.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              Syarat Reward
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Daftar syarat reward
            </p>
          </div>
        </div>
      </div>
      <div
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
      >
        <div class="flex justify-end">
          <BaseButton @click="onOpenRequireForm">Tambah Syarat</BaseButton>
        </div>
        <datatable
          :total="requireModal.data.meta.page.total"
          :perPage="requireModal.data.meta.page.perPage"
          :currentPage="requireModal.data.meta.page.currentPage"
          :columns="[
            { id: 'name', name: 'Nama' },
            { id: 'pv', name: 'PV' },
            { id: 'action', name: 'Aksi' },
          ]"
          @pagechanged="onRequirePageChange"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="require in requireModal.data.data"
              :key="require.id"
              :class="[classes.tr, 'bg-white']"
            >
              <td :class="classes.td">{{ require.attributes.name }}</td>
              <td :class="classes.td">
                <p class="truncate">{{ require.attributes.point_value}}</p>
              </td>
              <td :class="[classes.td]">
                <div class="flex gap-1">
                  <button
                    class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                    @click="onDeleteRequire(require)"
                  >
                    <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </base-modal>

    <base-modal
      :showing="imageModal.visible"
      @close="imageModal.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              Gambar Reward
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Daftar gambar reward
            </p>
          </div>
        </div>
      </div>
      <div
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
      >
        <div class="flex justify-end">
          <BaseButton @click="onOpenImageForm">Tambah Gambar</BaseButton>
        </div>
        <datatable
          :total="imageModal.data.meta.page.total"
          :perPage="imageModal.data.meta.page.perPage"
          :currentPage="imageModal.data.meta.page.currentPage"
          :columns="[
            { id: 'image', name: 'Gambar' },
            { id: 'date', name: 'Tanggal' },
            { id: 'action', name: 'Aksi' },
          ]"
          @pagechanged="onImagePageChange"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="image in imageModal.data.data"
              :key="image.id"
              :class="[classes.tr, 'bg-white']"
            >
              <td :class="classes.td">
                <img :src="`http://localhost:8000${image.attributes.fileurl}`" alt="" style="width: 100px;">
              </td>
              <td :class="classes.td">
                <p class="truncate">{{ image.attributes.createdAt | formatDate }}</p>
              </td>
              <td :class="[classes.td]">
                <div class="flex gap-1">
                  <button
                    class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                    @click="onDeleteImage(image)"
                  >
                    <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </base-modal>

    <base-modal
      :showing="requireForm.visible"
      @close="requireForm.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">Tambah Syarat</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">Tambah Syarat Baru</p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitRequireForm"
      >
        <base-input
          label="Nama"
          :shadow="false"
          fullwidth
          placeholder="Nama"
          type="text"
          required
          v-model="requireForm.name"
        />
        <base-input
          label="PV"
          :shadow="false"
          fullwidth
          placeholder="PV"
          type="number"
          required
          v-model="requireForm.point_value"
        />
        <div class="space-x-2">
          <base-button color="white" type="button" @click="requireForm.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-modal
      :showing="imageForm.visible"
      @close="imageForm.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">Tambah Gambar</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">Tambah Gambar Baru</p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitImageForm"
      >
        <base-input fullwidth :shadow="false" type="file" size="padding-md" inset label="Upload File"
          accept="image/*,video/*" required @change="onChangeUploadImage" />
        <div class="space-x-2">
          <base-button color="white" type="button" @click="imageForm.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-modal
      :showing="form.visible"
      @close="form.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              {{ form.type === 'create' ? 'Tambah Reward' : 'Edit Reward' }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              {{ form.type === 'create' ? 'Tambah Reward Baru' : 'Edit Reward' }}
            </p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitForm"
      >
        <base-input
          label="Judul Reward"
          :shadow="false"
          fullwidth
          placeholder="Judul Reward"
          type="text"
          required
          v-model="form.title"
        />
        <base-input
          label="Tanggal Mulai"
          :shadow="false"
          fullwidth
          type="date"
          required
          v-model="form.start_date"
        />
        <base-input
          label="Tanggal Selesai"
          :shadow="false"
          fullwidth
          type="date"
          required
          v-model="form.end_date"
        />
        <base-input
          label="Deskripsi Reward"
          :shadow="false"
          fullwidth
          placeholder="Deskripsi Reward"
          type="text"
          tag="textarea"
          rows="5"
          required
          v-model="form.description"
        />
        <div class="space-x-2">
          <base-button color="white" type="button" @click="form.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-confirm
      :visible="deleteConfirm.visible"
      title="Hapus Reward"
      message="Apakah anda yakin ingin menghapus volume ini?"
      icon-type="badge"
      @close="deleteConfirm.visible = false"
      @confirmed="onConfirmDelete"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '../../../../components/base/BaseModal.vue';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    BaseModal,
    BaseConfirm
  },
  data() {
    return {
      loadingRewards: false,
      deleteRequireLoading: false,
      deleteImageLoading: false,
      rewards: {
        data: [],
        meta: {
          page: {},
        },
      },
      form: {
        visible: false,
        loading: false,
        type: 'create',
        title: null,
        description: null,
        start_date: null,
        end_date: null,
        editId: null
      },
      requireForm: {
        visible: false,
        loading: false,
        name: null,
        point_value: null,
      },
      imageForm: {
        visible: false,
        loading: false,
        file: null,
      },
      deleteConfirm: {
        visible: false,
        loading: false,
        id: null
      },
      requireModal: {
        rewardId: null,
        visible: false,
        loading: false,
        data: {
          data: [],
          meta: {
            page: {},
          },
        }
      },
      imageModal: {
        rewardId: null,
        visible: false,
        loading: false,
        data: {
          data: [],
          meta: {
            page: {},
          },
        }
      }
    };
  },
  created() {
    this.loadRewards();
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onPageChange(page) {
      this.loadRewards({
        'page[number]': page
      });
    },
    onRequirePageChange(page) {
      this.loadRequires({
        'page[number]': page
      });
    },
    onImagePageChange(page) {
      this.loadImages({
        'page[number]': page
      });
    },
    onCreate() {
      this.form.type = 'create'
      this.form.title = null
      this.form.description = null
      this.form.start_date = null
      this.form.end_date = null
      this.form.editId = null
      this.form.visible = true;
    },
    onEdit(reward) {
      this.form.type = 'edit'
      this.form.title = reward.attributes.title
      this.form.description = reward.attributes.description
      this.form.start_date = reward.attributes.start_date
      this.form.end_date = reward.attributes.end_date
      this.form.editId = reward.id
      this.form.visible = true;
    },
    onOpenRequire(reward) {
      this.requireModal.rewardId = reward.id
      this.requireModal.visible = true;
      
      this.loadRequires()
    },
    onOpenImage(reward) {
      this.imageModal.rewardId = reward.id
      this.imageModal.visible = true;
      
      this.loadImages()
    },
    async onDeleteRequire(target) {
      this.deleteRequireLoading = true;

      const [, error] = await this.request(`/api/v1/reward-requires/${target.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.loadRequires();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteRequireLoading = false;
    },
    async onDeleteImage(target) {
      this.deleteImageLoading = true;

      const [, error] = await this.request(`/api/v1/reward-images/${target.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.loadImages();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteImageLoading = false;
    },
    onOpenRequireForm() {
      this.requireForm.visible = true
      this.requireForm.loading = false
      this.requireForm.name = null
      this.requireForm.point_value = null
    },
    onOpenImageForm() {
      this.imageForm.visible = true
      this.imageForm.loading = false
      this.imageForm.file = null
    },
    onChangeUploadImage(e) {
      const [files] = e.target.files

      this.imageForm.file = files ?? null
    },
    onDelete(reward) {
      this.deleteConfirm.id = reward.id
      this.deleteConfirm.visible = true
    },
    async onConfirmDelete() {
      this.deleteConfirm.loading = true;

      const [, error] = await this.request(`/api/v1/rewards/${this.deleteConfirm.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.deleteConfirm.visible = false;
        this.loadRewards();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteConfirm.loading = false;
    },
    async onSubmitForm() {
      this.form.loading = true;

      const [, error] = await this.request(this.form.type === 'create' ? '/api/v1/rewards' : `/api/v1/rewards/${this.form.editId}`, {
        method: this.form.type === 'create' ? 'post' : 'patch',
        data: {
          data: {
            type: 'rewards',
            ...(this.form.type === 'create' ? {} : { id: this.form.editId }),
            attributes: {
              title: this.form.title,
              description: this.form.description,
              start_date: this.form.start_date,
              end_date: this.form.end_date,
            },
          },
        },
      });

      if (!error) {
        this.form.visible = false;
        this.loadRewards();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.form.loading = false;
    },
    async onSubmitRequireForm() {
      this.requireForm.loading = true;

      const [, err] = await this.request('/api/v1/reward-requires', {
        method: 'post',
        data: {
          data: {
            type: 'reward-requires',
            attributes: {
              name: this.requireForm.name,
              point_value: Number(this.requireForm.point_value),
            },
            relationships: {
              reward: {
                data: {
                  type: 'rewards',
                  id: this.requireModal.rewardId
                }
              }
            }
          },
        },
      });

      if (!err) {
        this.requireForm.visible = false;
        this.loadRequires();
      } else {
        this.createAlert({
          data: err.message,
          status: 'err',
        });
      }

      this.requireForm.loading = false;
    },
    async onSubmitImageForm() {
      this.imageForm.loading = true;

      const formData = new FormData();

      formData.append('image', this.imageForm.file);

      const [, err] = await this.request(`/api/v1/rewards/${this.imageModal.rewardId}/-actions/upload-image`, {
        method: 'post',
        data: formData
      });

      if (!err) {
        this.imageForm.visible = false;
        this.loadImages();
      } else {
        this.createAlert({
          data: err.message,
          status: 'err',
        });
      }

      this.imageForm.loading = false;
    },
    async loadRewards(params) {
      this.loadingRewards = true;

      const [res, err] = await this.request('/api/v1/rewards', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          ...params,
        },
      });

      if (!err) {
        this.rewards = res;
      }

      this.loadingRewards = false;
    },
    async loadRequires(params) {
      this.requireModal.loading = true;

      const [res, err] = await this.request(`/api/v1/rewards/${this.requireModal.rewardId}/requires`, {
        params: {
          'page[size]': 5,
          'sort': '-id',
          ...params,
        },
      });

      if (!err) {
        this.requireModal.data = res;
      }

      this.requireModal.loading = false;
    },
    async loadImages(params) {
      this.imageModal.loading = true;

      const [res, err] = await this.request(`/api/v1/rewards/${this.imageModal.rewardId}/images`, {
        params: {
          'page[size]': 5,
          'sort': '-id',
          ...params,
        },
      });

      if (!err) {
        this.imageModal.data = res;
      }

      this.imageModal.loading = false;
    },
  },
};
</script>
